import { schema } from 'normalizr'

const shopProductImage = new schema.Entity('shopProductImages')

export default shopProductImage
